const {
	actions: { toggleModal },
} = window.Edocat.Components.ModalTest;
const Input = window.Edocat.Components.TextField;

import { ControlInterface } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Dispatch } from 'redux';
import { addNewContact } from '../../../actions/form';

const {
	ModalTest: { default: Modal },
	Button,
} = window.Edocat.Components;

interface NewContactModalProps extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	params: any;
	view: boolean;
	index: number;
}

interface NewContactModalState {
	name: string;
	phone: string;
	email: string;
	note: string;
}

class NewContactModal extends React.PureComponent<NewContactModalProps, NewContactModalState> {
	constructor(props: NewContactModalProps) {
		super(props);
		this.state = {
			name: '',
			phone: '',
			email: '',
			note: '',
		};
	}
	onClose = (event?: React.MouseEvent) => {
		event && event.preventDefault();
		const { actions, formInstanceId } = this.props;
		actions.toggleModal(false, 'newContactModal', null, formInstanceId);
	};

	handleChange = (event: React.ChangeEvent, name: NewContactModalState | string) => {
		const { value } = event.target as HTMLInputElement;
		this.setState({ [name]: value });
	};

	handleSubmit = () => {
		const { actions, index, formInstanceId, name } = this.props;
		const value = this.state;
		actions.addNewContact(formInstanceId, index, value, name);
		this.onClose();
	};

	render() {
		const { formInstanceId } = this.props;

		return (
			<Modal
				className={'new-contacts-modal'}
				hideActionButtons
				onClose={this.onClose}
				name={'newContactModal'}
				reducerPath={[formInstanceId, 'formModal']}
				title={'Kontakty'}
			>
				<div className="modal-body">
					<div className="form-row">
						<Input
							label={window.Alfresco.messages.global['label.companyname']}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'name')}
							value={this.state.name}
						/>
					</div>
					<div className="form-row">
						<Input
							label={window.Alfresco.messages.global['label.companytelephone']}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'phone')}
							value={this.state.phone}
						/>
					</div>
					<div className="form-row">
						<Input
							label={window.Alfresco.messages.global['button.view.email']}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'email')}
							value={this.state.email}
						/>
					</div>
					<div className="form-row">
						<Input
							label={'Poznámka'}
							onChange={(event: React.ChangeEvent) => this.handleChange(event, 'note')}
							value={this.state.note}
						/>
					</div>
				</div>
				<div className="modal-actions">
					<Button primary label={window.Alfresco.messages.global['button.save']} onClick={this.handleSubmit} />
					<Button label={window.Alfresco.messages.global['button.close']} onClick={this.onClose} />
				</div>
			</Modal>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators({ toggleModal, addNewContact }, dispatch),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(NewContactModal);
